import { render, staticRenderFns } from "./RetailIndex.vue?vue&type=template&id=c222a318&scoped=true&"
import script from "./RetailIndex.vue?vue&type=script&lang=js&"
export * from "./RetailIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c222a318",
  null
  
)

export default component.exports